export const engagementPresetEmailTemplates = "/engagement/preset_email_templates";
